export default {
  name: 'dark',
  fontFamily: '"Roboto Mono", Menlo, monospace',
  fontWeights: {
    regular: 300,
    bold: 500
  },
  colors: {
    black: '#010101',
    white: '#fefefe',
    orange: '#eb8636',
    red: '#c00',
    silver: '#bcbcbc',
    darkSilver: '#4a4a4a',
    gray: '#999',
    darkGray: '#808080',
    green: '#5bbe0e',
    darkGreen: '#479908',
    blue: '#0a83f7',
    darkBlue: '#024594'
  },
  palette: {
    primary: {
      base: '#ff3333',
      dark: '#cc0000',
      text: '#FF0'
    },
    secondary: {
      base: '#ff9933',
      dark: '#cc6600',
      text: '#F0F'
    },
    text: {
      base: '#024599',
      light: '#f00',
      lighter: '#f0f',
      lightest: '#13da13',
      dark: '#040'
    },
    background: {
      base: '#bbb',
      darker: '#aaa',
      primary: '#333'
    }
  }
};